import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import { META_ROW_HEIGHT } from '@/components/organisms/PageHeader/constants';
import { MetaLoadingProvider } from '@/components/organisms/PageHeader/metaLoadingContext';

type PageHeaderMetaProps = {
  /**
   * A list of `PageHeader.MetaItem` elements. Other content is accepted by the
   * type system but not by the design-system contract — keep children to
   * `MetaItem` only.
   */
  children?: ReactNode;
  /**
   * When true, cascades `isLoading` to every descendant `MetaItem` that does
   * not set its own `isLoading` explicitly. The row keeps its icons visible;
   * only values skeletonize. See ADR-006.
   */
  isLoading?: boolean;
};

export const PageHeaderMeta = ({ children, isLoading = false }: PageHeaderMetaProps) => {
  return (
    <MetaLoadingProvider value={isLoading}>
      <Stack direction="row" alignItems="center" sx={{ mt: 0.5, height: META_ROW_HEIGHT, overflow: 'hidden' }}>
        {children}
      </Stack>
    </MetaLoadingProvider>
  );
};
